import { render } from "./IndustryPlatformList.vue?vue&type=template&id=09ceaa4e&scoped=true"
import script from "./IndustryPlatformList.vue?vue&type=script&lang=js"
export * from "./IndustryPlatformList.vue?vue&type=script&lang=js"

import "./IndustryPlatformList.vue?vue&type=style&index=0&id=09ceaa4e&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ceaa4e"]])

export default __exports__